import {UserRole} from "../../user/models/model";

export const UserTransfersAccess = [
    UserRole.OWNER,
    UserRole.AGENT
]